import * as React from 'react';
import {
  useAccountPositionEstim,
  useAccountPositionEstimTotalBySTypeGroup,
  useAccountPositionEstimTotal,
} from '../../hooks';
import { ActorApiNumberDisplayCurrency } from '../../../../../../components/display/number/currency';
import { usePersonAccountsCCurrencyTAccCode } from '../../../../persons';

export const AccountsPositionsGesEstimDEstim = () => {
  const {
    data,
    isLoading,
    error,
  } = useAccountPositionEstim();
  const {
    data: currencyData,
    isLoading: currencyIsLoading,
    error: currencyError,
  } = usePersonAccountsCCurrencyTAccCode();
  return (
    <ActorApiNumberDisplayCurrency
      data={data}
      isLoading={isLoading}
      error={error}
      currencyData={currencyData}
      currencyIsLoading={currencyIsLoading}
      currencyError={currencyError}
    />
  );
};

export const AccountsPositionsGesEstimDEstimTotalBySTypeGrp = () => {
  const {
    data,
    isLoading,
    error,
  } = useAccountPositionEstimTotalBySTypeGroup();
  const {
    data: currencyData,
    isLoading: currencyIsLoading,
    error: currencyError,
  } = usePersonAccountsCCurrencyTAccCode();
  return (
    <ActorApiNumberDisplayCurrency
      data={data}
      isLoading={isLoading}
      error={error}
      currencyData={currencyData}
      currencyIsLoading={currencyIsLoading}
      currencyError={currencyError}
    />
  );
};

export const AccountsPositionsGesEstimDEstimTotal = () => {
  const {
    data,
    isLoading,
    error,
  } = useAccountPositionEstimTotal();
  const {
    data: currencyData,
    isLoading: currencyIsLoading,
    error: currencyError,
  } = usePersonAccountsCCurrencyTAccCode();
  return (
    <ActorApiNumberDisplayCurrency
      data={data}
      isLoading={isLoading}
      error={error}
      currencyData={currencyData}
      currencyIsLoading={currencyIsLoading}
      currencyError={currencyError}
    />
  );
};
